export const FETCH_ORDER_DETAILS_INIT = 'FETCH_ORDER_DETAILS_INIT';
export const FETCH_ORDER_DETAILS_DONE = 'FETCH_ORDER_DETAILS_DONE';
export const FETCH_ORDER_DETAILS_FAIL = 'FETCH_ORDER_DETAILS_FAIL';
export const ACTIVATE_DEVICE_INIT = 'ACTIVATE_DEVICE_INIT';
export const ACTIVATE_DEVICE_DONE = 'ACTIVATE_DEVICE_DONE';
export const ACTIVATE_DEVICE_FAIL = 'ACTIVATE_DEVICE_FAIL';
export const DEACTIVATE_DEVICE_INIT = 'DEACTIVATE_DEVICE_INIT';
export const DEACTIVATE_DEVICE_DONE = 'DEACTIVATE_DEVICE_DONE';
export const DEACTIVATE_DEVICE_FAIL = 'DEACTIVATE_DEVICE_FAIL';
